import React from 'react';
import { PopoverInteractionKind } from '@blueprintjs/core';
import { Link, Text, Tooltip } from 'core/components';
import GeneralIndicator from 'core/components/GeneralIndicator';

export const PLAN_LEGACY_KPROXY_WARNING: JSX.Element = (
  <>
    <Text fontWeight="bold">Warning: License Estimation Impacted</Text>
    <br />
    <Text>
      Your current license estimation may be inaccurate due to outdated agents running on your network. To resolve this
      data anomaly and ensure accurate metrics, we recommend migrating to{' '}
      <Link blank rel="noopener noreferrer" to="https://kb.kentik.com/docs/migrate-from-kproxy-to-universal-agent">
        the Universal Agent.
      </Link>
    </Text>
  </>
);

export const DEVICE_LEGACY_KPROXY_WARNING: JSX.Element = (
  <>
    <Text fontWeight="bold">Warning: FPS Estimation Impacted</Text>
    <br />
    <Text>
      This device&apos;s FPS estimation may be inaccurate due to outdated agents running on this device. <br />
      To resolve this data anomaly and ensure accurate metrics, we recommend migrating to{' '}
      <Link blank rel="noopener noreferrer" to="https://kb.kentik.com/docs/migrate-from-kproxy-to-universal-agent">
        the Universal Agent.
      </Link>
    </Text>
  </>
);

interface LegacyKproxyIndicatorProps {
  text?: string;
  title?: string | JSX.Element;
}

function LegacyKproxyIndicator({
  text = 'Legacy Kproxy Version',
  title = DEVICE_LEGACY_KPROXY_WARNING
}: LegacyKproxyIndicatorProps) {
  return (
    <Tooltip content={title} interactionKind={PopoverInteractionKind.HOVER} hoverCloseDelay={100}>
      <GeneralIndicator intent="danger" text={text} interactive={false} />
    </Tooltip>
  );
}

export default LegacyKproxyIndicator;
